import axiosWrapper, { InterceptorOptions } from './axios-wrapper'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiGetShifts({ plant_name }) {
  return api
    .get(`/plants/shifts?plantName=${plant_name}`)
    .then((resp) => resp.data)
}
